module.exports = __webpack_public_path__ + "static/media/barberscape-5.76343569.jpg";